import { TemporalRelationConfig as ApiRelationConfig } from "../../entities/NSwagGenerated"

export type QueryMode = "all" | "asOf" | "between"

export interface TemporalRelationConfig {
	entity: string
	fk?: string
	projections?: string[]
	relations?: TemporalChildRelationConfig[]
}

// A relation nested under another entity must specify which FK ties it to its parent -
// only the root entity in a config tree has no parent, so only it can omit 'fk'.
export interface TemporalChildRelationConfig extends TemporalRelationConfig {
	fk: string
}

export function toApiConfig(config: TemporalRelationConfig): ApiRelationConfig {
	return new ApiRelationConfig({
		entity: config.entity,
		fk: config.fk,
		projections: config.projections ?? [],
		relations: (config.relations ?? []).map(toApiConfig),
	})
}

export type TemporalLoadRequest =
	| { mode: "all" }
	| { mode: "asOf"; asOf: Date }
	| { mode: "between"; from: Date; to: Date }

export interface TemporalFieldDisplay {
	label: string
	nameField: string
	alwaysShow?: boolean
}

export interface TemporalDisplayConfig {
	[entityKey: string]: {
		label?: string
		fields?: string[]
		projections?: Record<string, TemporalFieldDisplay>
	}
}

export interface FieldValue {
	field: string
	value: unknown
	alwaysShow?: boolean
}

export interface FieldChange {
	field: string
	from: unknown
	to: unknown
}

export type ChangeEventType = "created" | "updated" | "deleted"

export interface ChangeEvent {
	entityKey: string
	label: string
	eventType: ChangeEventType
	personName: string
	timestamp: string
	fields: FieldValue[]
	changes: FieldChange[]
}
